import { useState, useEffect } from "react";

const FIELDS = [
  { label: "Contest Name", value: "Summer Giveaway 2025" },
  { label: "End Date", value: "Aug 31, 2025" },
];

const METHODS = [
  { emoji: "📸", label: "Follow on Instagram", tag: "+1 entry", color: "#0d9488" },
  { emoji: "🌐", label: "Visit Website", tag: "+1 entry", color: "#f97316" },
  { emoji: "👥", label: "Refer a Friend", tag: "+5 entries", color: "#6366f1" },
];

export default function CreateContest(): JSX.Element {
  const [methodsShown, setMethodsShown] = useState(0);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      count++;
      setMethodsShown(count);
      if (count >= METHODS.length) {
        clearInterval(interval);
        setTimeout(() => setShowButton(true), 400);
        setTimeout(() => {
          setMethodsShown(0);
          setShowButton(false);
        }, 3500);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [showButton === false && methodsShown === 0 ? 0 : 1]);

  // Restart loop
  useEffect(() => {
    if (methodsShown === 0 && !showButton) {
      let count = 0;
      const interval = setInterval(() => {
        count++;
        setMethodsShown(count);
        if (count >= METHODS.length) {
          clearInterval(interval);
          setTimeout(() => setShowButton(true), 400);
          setTimeout(() => {
            setMethodsShown(0);
            setShowButton(false);
          }, 3500);
        }
      }, 500);
      return () => clearInterval(interval);
    }
  }, [methodsShown, showButton]);

  return (
    <div style={{
      width: "100%", maxWidth: 400, height: "auto", minHeight: 200, aspectRatio: "3/2", overflow: "hidden",
      background: "#fff", borderRadius: 14,
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: "flex", flexDirection: "column",
    }}>
      {/* Header */}
      <div style={{
        background: "#f8fafc", borderBottom: "1px solid #e2e8f0",
        padding: "10px 14px", display: "flex",
        alignItems: "center", justifyContent: "space-between",
        flexShrink: 0,
      }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>
          🎁 New Contest
        </span>
        <span style={{
          fontSize: 10, fontWeight: 600, color: "#0d9488",
          background: "rgba(13,148,136,0.08)",
          padding: "2px 8px", borderRadius: 20,
        }}>Step 1 of 2</span>
      </div>

      {/* Body */}
      <div style={{ padding: "12px 14px", flex: 1, overflow: "hidden" }}>
        {/* Pre-filled fields */}
        {FIELDS.map((f, i) => (
          <div key={i} style={{ marginBottom: 5 }}>
            <div style={{
              fontSize: 9, fontWeight: 600, color: "#94a3b8",
              textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3
            }}>
              {f.label}
            </div>
            <div style={{
              background: "#f8fafc", border: "1px solid #e2e8f0",
              borderRadius: 7, padding: "5px 9px",
              fontSize: 10, color: "#0f172a", fontWeight: 500,
              display: "flex", justifyContent: "space-between",
            }}>
              {f.value}
              <span style={{ color: "#0d9488" }}>✓</span>
            </div>
          </div>
        ))}

        {/* Entry methods label */}
        <div style={{
          fontSize: 9, fontWeight: 600, color: "#94a3b8",
          textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6
        }}>
          Entry Methods
        </div>

        {/* Methods appearing */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {METHODS.map((m, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "5px 8px",
              background: methodsShown > i ? "#f8fafc" : "transparent",
              border: `1px solid ${methodsShown > i ? "#e2e8f0" : "transparent"}`,
              borderRadius: 7,
              opacity: methodsShown > i ? 1 : 0.15,
              transform: methodsShown > i ? "translateX(0)" : "translateX(-6px)",
              transition: "all 0.3s cubic-bezier(0.34,1.56,0.64,1)",
            }}>
              <span style={{ fontSize: 13 }}>{m.emoji}</span>
              <span style={{ fontSize: 10, color: "#475569", flex: 1, fontWeight: 500 }}>
                {m.label}
              </span>
              <span style={{
                fontSize: 9, fontWeight: 700, color: m.color,
                background: `${m.color}12`,
                padding: "2px 6px", borderRadius: 20,
              }}>{m.tag}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer button */}
      <div style={{
        padding: "0 14px 12px",
        opacity: showButton ? 1 : 0,
        transform: showButton ? "translateY(0)" : "translateY(6px)",
        transition: "all 0.35s cubic-bezier(0.34,1.56,0.64,1)",
        flexShrink: 0,
      }}>
        <div style={{
          background: "linear-gradient(135deg, #f97316, #ea580c)",
          borderRadius: 8, padding: "8px",
          textAlign: "center", fontSize: 11,
          fontWeight: 700, color: "#fff",
          boxShadow: "0 3px 12px rgba(249,115,22,0.3)",
        }}>🚀 Publish Contest</div>
      </div>
    </div>
  );
}
